// @flow
export { default as UserProfileHeading } from './UserProfileHeading';
